import * as Comlink from 'comlink'
import { runtimeMonitor } from './runtime'

/**
 * A module worker behind Comlink that keeps the main thread free: the caller awaits `remote` calls while the work
 * runs in the worker. The worker is observed by the runtime monitor until `close()`.
 * Proven in a real Chromium module worker by module-worker.browser.test.ts.
 */
export function createModuleWorker<Api extends object>(spawn: () => Worker, info: { name: string }) {
  const endpoint = spawn()
  const observed = runtimeMonitor.observeWorker(endpoint, { name: info.name, kind: 'dedicated' })
  const remote = Comlink.wrap<Api>(endpoint)
  return {
    remote,
    close() { observed.close(); endpoint.terminate() },
  }
}
